import * as d3 from 'd3';
import { DefaultTheme } from 'styled-components';
import theme from 'src/theme/theme';

type Arguments = {
  xValue: number;
  graph: d3.Selection<null, unknown, null, undefined>;
  pillWidth: number;
  text: string;
  xScale: d3.ScaleLinear<number, number, never>;
  yScale: d3.ScaleLinear<number, number, never>;
  yPosition: number;
  theme?: DefaultTheme;
};
export const createDaysLine = ({
  xValue,
  graph,
  pillWidth,
  text,
  xScale,
  yScale,
  yPosition,
  theme: t,
}: Arguments) => {
  const isAtlas = t && !t.isVaultVariant;
  const strokeColor = isAtlas
    ? t.atlas.semantic.color.type.default
    : theme.newPalette.neutral.N800;
  const textColor = isAtlas
    ? t.atlas.semantic.color.type.inverse
    : theme.newPalette.neutral.N0;
  const pillHeight = 28;
  graph
    .append('line')
    .attr('x1', xScale(xValue))
    .attr('y1', yScale(0) + 20)
    .attr('x2', xScale(xValue))
    .attr('y2', yScale(yPosition))
    .attr('stroke-width', '1.5')
    .style('stroke', strokeColor);
  graph
    .append('rect')
    .attr('x', xScale(xValue) - pillWidth / 2)
    .attr('y', yScale(yPosition) - pillHeight)
    .attr('width', pillWidth)
    .attr('height', pillHeight)
    .attr('rx', 14)
    .attr('ry', 14)
    .style('fill', strokeColor)
    .style('stroke', strokeColor);
  graph
    .append('text')
    .attr('x', xScale(xValue))
    .attr('y', yScale(yPosition) - 10)
    .attr('fill', textColor)
    .style('font-size', theme.newTypography.textStyleBodySmall.fontSize)
    .style('font-family', theme.newTypography.textStyleBodySmall.fontFamily)
    .attr('text-anchor', 'middle')
    .text(text);
};
